import type {RefObject} from 'react'
import {FormControl, TextInput} from '@primer/react'
import {useValidateRegex} from '@github-ui/repos-async-validation/use-validate-regex'
import type {RegisteredRuleSchemaComponent} from '../../../types/rules-types'

export function RegexField({field, value, onValueChange, readOnly, fieldRef, errors}: RegisteredRuleSchemaComponent) {
  if (field.type !== 'string') {
    throw new Error('Field type must be string')
  }

  const regexValidator = useValidateRegex()

  if (readOnly) {
    return (
      <div>
        <span className="text-bold">{field.display_name}: </span>
        <span>{value as string}</span>
        <span className="d-block text-small color-fg-muted">{field.description}</span>
      </div>
    )
  }

  return (
    <FormControl>
      <FormControl.Label>{field.display_name}</FormControl.Label>
      <FormControl.Caption>{field.description}</FormControl.Caption>
      <TextInput
        data-testid="regex-field-pattern"
        className="width-full"
        type={'text'}
        aria-invalid={errors.length > 0 || regexValidator.showError}
        ref={fieldRef as RefObject<HTMLInputElement>}
        value={(value || '') as string}
        onChange={e => {
          regexValidator.reset()
          onValueChange(e.target.value)
        }}
        onBlur={e => {
          regexValidator.validate(e.target.value)
        }}
      />
      {errors.length > 0 ? (
        <FormControl.Validation variant="error">{errors[0]?.message}</FormControl.Validation>
      ) : regexValidator.showError ? (
        <FormControl.Validation variant="error">Invalid pattern</FormControl.Validation>
      ) : null}
    </FormControl>
  )
}

try{ RegexField.displayName ||= 'RegexField' } catch {}